<template>
    <div>
        <img v-if="(userType===1)" class="top-img" src="./../../images/top.png" alt="" />
        <img v-else class="top-img" src="./../../images/no-top.png" alt="" />
    </div>
</template>
<script>
export default{
    props:{
        userType:{
            type:Number,
            default:1
        }
    },
 
}
</script>
<style scoped lang="stylus">
@import url("./index.styl")
</style>